









import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
import HiddenInput from '@/types/HiddenInput.interface'
import HiddenInputComponent from '@/components/HiddenInput.vue'
export default Vue.extend({
    components: { 'hidden-input': HiddenInputComponent },
    props: {
        //  Makes the component a readonly input (used for display without edit)
        readonly: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    computed: {
        //  Profiles items for person names
        nameItems(): HiddenInput[] {
            return [
                {
                    name: 'Full Name',
                    label: 'Full Name',
                    editable: true,
                    validate: 'max:191',
                    value: this.person.name_full,
                    callback: (val: string) => (this.person.name_full = val)
                },
                {
                    name: 'Title',
                    label: 'Title',
                    editable: true,
                    validate: 'max:55',
                    value: this.person.name_title,
                    callback: (val: string) => (this.person.name_title = val)
                },
                {
                    name: 'First Name',
                    label: 'First Name',
                    editable: true,
                    validate: 'max:55',
                    value: this.person.name_given,
                    callback: (val: string) => (this.person.name_given = val)
                },
                {
                    name: 'Middle Name',
                    label: 'Middle Name',
                    editable: true,
                    validate: 'max:55',
                    value: this.person.name_middle,
                    callback: (val: string) => (this.person.name_middle = val)
                },
                {
                    name: 'Last Name',
                    label: 'Last Name',
                    editable: true,
                    validate: 'max:55',
                    value: this.person.name_family,
                    callback: (val: string) => (this.person.name_family = val)
                },
                {
                    name: 'Suffix',
                    label: 'Suffix',
                    editable: true,
                    validate: 'max:25',
                    value: this.person.name_suffix,
                    callback: (val: string) => (this.person.name_suffix = val)
                },
                {
                    name: 'Created At',
                    label: 'Created At',
                    editable: false,
                    value: this.personCreatedAt,
                }
            ]
        },
        //  Takes the created_at date from the person's table and parses out "2023-10-30" and returns that value so we don't include hh:mm:ss, this is used for Created At field
        personCreatedAt(): String {
            return this.person.created_at.split(' ')[0]
        }
    }
})
